import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiRootService } from '../apiroot.service';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class EngineParamEntryService {

  constructor(private http: HttpClient, private service: ApiRootService) { }

  public saveParams(params: any[]): Observable<any> {
    const url = this.service.getBaseUrl() + '/api/enginparameter/save';
    return this.http.post(url, params, {
      headers: { 'Content-Type': 'application/json' }
    });
  }

  public deleteParams(id: string, vesselId: number, voyageNumber: string) {
    const url = `${this.service.getBaseUrl()}/api/softDeleteEngineParameterByIdAndVesselIdAndVoyageNumber/${id}/${vesselId}/${voyageNumber}`;
    return this.http.delete(url);
  }
  
  
  
}
